// extracted by mini-css-extract-plugin
export default {"Box":"column-drop-zone-sash-module__Box--F8tYn","Box_1":"column-drop-zone-sash-module__Box_1--_GPQr"};